import { useQuery } from '@tanstack/react-query'
import { collectorService } from '@/api/services/collectorService'

export function useCollectorOverview() {
  return useQuery({ queryKey: ['collector', 'overview'], queryFn: () => collectorService.adminCashInHand(), staleTime: 30_000 })
}
export function useCollectorCashInHand(p?: Parameters<typeof collectorService.adminCashInHand>[0]) {
  return useQuery({ queryKey: ['collector', 'cash-in-hand', p], queryFn: () => collectorService.adminCashInHand(p), staleTime: 30_000 })
}
export function useCollectorCollectedList(p?: Parameters<typeof collectorService.adminCollectedCash>[0]) {
  return useQuery({ queryKey: ['collector', 'collected', p], queryFn: () => collectorService.adminCollectedCash(p), staleTime: 30_000 })
}
